import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#171717",
      "fill-rule": "evenodd",
      d: "m14.213 9.24-1.658 5.25a.72.72 0 0 1-.675.51l-5.167-.75c-.398 0-.713-.338-.713-.75V7.943q.403-.182.75-.443c.285-.218.532-.465.75-.75.473-.622.75-1.402.75-2.25V3H9c.412 0 .75.337.75.75v4.5h3.787c.488 0 .833.502.675.99M3.75 15h1.5V7.5h-1.5zm10.958-6.9a1.43 1.43 0 0 0-1.17-.6H10.5V3.75c0-.825-.675-1.5-1.5-1.5h-.75a.77.77 0 0 0-.57.263A.75.75 0 0 0 7.5 3v1.5a2.99 2.99 0 0 1-1.59 2.648.74.74 0 0 0-.66-.398h-1.5a.74.74 0 0 0-.66.397A.7.7 0 0 0 3 7.5V15c0 .412.337.75.75.75h1.5c.412 0 .75-.338.75-.75v-.195q.294.171.645.195l5.13.742c.037.008.067.008.105.008a1.46 1.46 0 0 0 1.387-1.035l1.658-5.25c.15-.465.067-.975-.218-1.365",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }